export const state = {
  fat: null,
  protein: null,
  carbs: null,
  weight: null, //pounds by default
  height: 69, //inches by default
  heightOptions: [
    { text: `4'6"`, value: 54 },
    { text: `4'7"`, value: 55 },
    { text: `4'8"`, value: 56 },
    { text: `4'9"`, value: 57 },
    { text: `4'10"`, value: 58 },
    { text: `4'11"`, value: 59 },
    { text: `5'0"`, value: 60 },
    { text: `5'1"`, value: 61 },
    { text: `5'2"`, value: 62 },
    { text: `5'3"`, value: 63 },
    { text: `5'4"`, value: 64 },
    { text: `5'5"`, value: 65 },
    { text: `5'6"`, value: 66 },
    { text: `5'7"`, value: 67 },
    { text: `5'8"`, value: 68 },
    { text: `5'9"`, value: 69 },
    { text: `5'10"`, value: 70 },
    { text: `5'11"`, value: 71 },
    { text: `6'0"`, value: 72 },
    { text: `6'1"`, value: 73 },
    { text: `6'2"`, value: 74 },
    { text: `6'3"`, value: 75 },
    { text: `6'4"`, value: 76 },
    { text: `6'5"`, value: 77 },
    { text: `6'6"`, value: 78 },
    { text: `6'7"`, value: 79 },
    { text: `6'8"`, value: 80 },
    { text: `6'9"`, value: 81 },
  ],
  bodyTypeOptions: [
    { text: 'Select a Body Type', value: '' },
    { text: 'Ectomorph', value: 'ectomorph' },
    { text: 'Mesomorph', value: 'mesomorph' },
    { text: 'Endomorph', value: 'endomorph' },
  ],
  bodyTypeValue: null,
  calories: null,
  targetWeight: null,
  age: null,
  genderOptions: [{ title: 'male', value: 0 }, { title: 'female', value: 1 }],
  genderSelectionIndex: null,
  activityLevelOptions: [
    { title: 'No Activity', value: 0 },
    { title: 'Active 1-3 days per week', value: 1 },
    { title: 'Train 4-5 days per week', value: 2 },
    { title: 'Train 5+ times per week', value: 3 },
  ],
  activityLevelSelectionIndex: null,
  goalOptions: [{ title: 'Weight Loss', value: 0 }, { title: 'Maintain / Tone', value: 1 }, { title: 'Weight Gain', value: 2 }],
  goalSelectionIndex: null,
};

export const mutations = {
  setMacrosFat(state, data) {
    state.fat = data;
  },
  setMacrosProtein(state, data) {
    state.protein = data;
  },
  setMacrosCarbs(state, data) {
    state.carbs = data;
  },
  setMacrosWeight(state, data) {
    state.weight = Math.round(data);
  },
  setMacrosHeight(state, data) {
    state.height = data;
  },
  setMacrosAge(state, data) {
    state.age = data;
  },
  setMacrosTargetWeight(state, data) {
    state.targetWeight = data;
  },
  setMacrosCalories(state, data) {
    state.calories = data;
  },
  setMacrosGenderSelectionIndex(state, data) {
    state.genderSelectionIndex = data;
  },
  setMacrosBodyTypeValue(state, data) {
    state.bodyTypeValue = data;
  },
  setMacrosActivityLevelSelection(state, data) {
    state.activityLevelSelectionIndex = data;
  },
  setMacrosGoalSelectionIndex(state, data) {
    state.goalSelectionIndex = data;
  },
};

export const getters = {
  heightInCm: (state) => {
    return state.height * 2.54;
  },
  weightInKg: (state) => {
    return state.weight * 0.45;
  },
};

export const actions = {};
